/**
 * SnapshotRestorationService - Handles selective snapshot restoration
 */

import { ApplicationSnapshot, PartialApplicationSnapshot, SnapshotRestorationOptions } from '../types/applicationState';
import { deepClone } from './clone';

export class SnapshotRestorationService {
  /**
   * Extract partial snapshot based on restoration options
   */
  static extractPartialSnapshot(
    state: ApplicationSnapshot,
    options: SnapshotRestorationOptions
  ): PartialApplicationSnapshot {
    const partial: PartialApplicationSnapshot = {};

    if (options.restoreData) {
      partial.projectData = this.cloneApplicationState(state).projectData;
    }

    if (options.restoreViewStates) {
      partial.viewStates = {};
      if (options.features) {
        // Only restore specified features
        options.features.forEach(feature => {
          if (state.viewStates[feature]) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            partial.viewStates![feature] = this.cloneApplicationState(state).viewStates[feature] as any;
          }
        });
      } else {
        // Restore all view states
        partial.viewStates = this.cloneApplicationState(state).viewStates;
      }
    }

    if (options.restoreUIState) {
      partial.uiState = this.cloneApplicationState(state).uiState;
    }

    if (options.restoreTreeState) {
      partial.treeState = this.cloneApplicationState(state).treeState;
    }

    if (options.restoreFilterState) {
      partial.filterState = this.cloneApplicationState(state).filterState;
    }

    return partial;
  }

  /**
   * Deep clone application state to ensure immutability
   */
  private static cloneApplicationState(state: ApplicationSnapshot): ApplicationSnapshot {
    return deepClone(state);
  }
}
